export const ESC_KEY = 'Escape'
export const ENTER_KEY = 'Enter'
export const ARROW_UP_KEY = 'ArrowUp'
export const ARROW_DOWN_KEY = 'ArrowDown'
